<template>
  <div class="operate_box">
    <van-button type="default" size="small" round text="说两句..." class="comment_btn" @click="showCommentForm" v-if="allowComment"></van-button>
    <van-button type="default" size="small" round text="说两句..." class="comment_btn" disabled v-else></van-button>
    <div class="operate_right">
      <span class="comment" @click="onCommentClick($event)">
        <Icon iconClass="comment" v-if="isTop" />
        <Icon iconClass="text" v-else />
      </span>
      <span class="praise"  ref="praise1" @click="onPraiseClick($event)" v-if="allowLikes">
        <Icon iconClass="candle" v-if="likeType=='10' && isLiked==false" />
        <Icon iconClass="candle-on" v-else-if="likeType=='10' && isLiked==true" />
        <Icon iconClass="pray" v-else-if="likeType=='11' && isLiked==false" />
        <Icon iconClass="pray-on" v-else-if="likeType=='11' && isLiked==true" />
        <Icon iconClass="praise" ref="praiseRef" v-else />
      </span>
      <span class="collect" ref="collect" @click="onCollectClick($event)">
        <Icon iconClass="collect" />
      </span>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { addScore } from "@/utils";
import commApi from "@/api/apis/common.js";
export default {
  name: "Operate",
  props: {
    params: {
      type: Object,
      default: null,
    },
    contentId: {
      type: Number,
      default: "",
    },
    contentTitle: {
      type: String,
      default: "",
    },
    isCollect: {
      type: Number,
      default: 0,
    },
    allow: {
      type: Boolean,
      default: false,
    },
    likeType: {
      type: String,
      default: "",
    },
    detailInfo:{},
    deviceId: {
      type: String,
      default: null,
    },
    isPraise:{},
    allowLikes:{}
    
  },
  computed: {
    ...mapState("app", ["userInfo"]),
  },
  data() {
    return {
      isTop: true, // 默认显示顶部
      allowComment: false, // 默认不允许评论
      isLiked: false,
    };
  },
  watch: {
    isCollect: {
      handler(newValue, oldValue) {
        if (!!this.userInfo && !!newValue) {
          if (this.isCollect == 1) {
            var target = this.$refs.collect;
            target.classList.add("collected");
          } else {
            var target = this.$refs.collect;
            target.classList.remove("collected");
          }
        }
      },
      deep: true,
    },
    allow: {
      handler(newValue, oldValue) {
        this.allowComment = newValue;
      },
      deep: true,
    },
   
    isPraise: {
      handler(newValue, oldValue) {
        
        if (newValue!=oldValue) {
          this.getThumbsUpStatus();
        }
      },
    },
  },
  methods: {
    /* 显示评论表单 */
    showCommentForm() {
      if (this.allowComment) {
        if (!!this.userInfo) {
          this.$emit("showCommentForm", true);
        } else {
          this.$router.push("/login");
        }
      }
    },
    /* 滚动到评论区域或顶部 */
    onCommentClick(event) {
      var _this = this;
      var target = event.currentTarget;
      var clsArray = target.firstElementChild.classList;
      if (clsArray.contains("tj-icon-comment")) {
        _this.isTop = false;
        _this.$emit("isToComment", true);
      } else {
        _this.isTop = true;
        _this.$emit("isToComment", false);
      }
    },
    /* 点赞、取消点赞 */
    onPraiseClick(event) {
      var _this = this;
      var target = event.currentTarget;
      let clsArray = target.classList;

      var params = {
        contentType: _this.detailInfo.contentType,
        contentId: _this.detailInfo.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }
      if (clsArray.contains("praised")) {
        commApi
          .cancelThumbsUp(params)
          .then((res) => {
            if (res.suc == 1) {
              clsArray.remove("praised");
              _this.isLiked = false;
              _this.$emit('changeIsPraise')
            } else {
              _this.$toast({
                message: res.message,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      } else {
        commApi
          .giveThumbsUp(params)
          .then((res) => {
            if (res.suc == 1) {
              target.classList.add("praised");
              _this.isLiked = true;
              _this.addScore("dz"); // 点赞增加积分
              _this.$emit('changeIsPraise')
            } else {
              _this.$toast({
                message: res.message,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      }
    },
    /* 收藏 */
    onCollectClick(event) {
      if (!!this.userInfo) {
        var _this = this;
        var target = event.currentTarget;
        let clsArray = target.classList;

        var params = {
          contentType: _this.params.contentType,
          contentId: _this.contentId,
          isSpecial: _this.params.fromFlag,
          memberId: _this.userInfo.id,
        };
        if (clsArray.contains("collected")) {
          commApi
            .cancelMemberCollect(params)
            .then((res) => {
              if (res.suc == 1) {
                clsArray.remove("collected");
              } else {
                _this.$toast({
                  message: res.message,
                  position: "center",
                });
              }
            })
            .catch((err) => {
              _this.$toast({
                message: "接口调用出错",
                position: "center",
              });
            });
        } else {
          commApi
            .addMemberCollect(params)
            .then((res) => {
              if (res.suc == 1) {
                target.classList.add("collected");
                _this.addScore(); // 增加积分
              } else if (res.message == "该内容已收藏") {
                target.classList.add("collected");
              } else {
                _this.$toast({
                  message: res.message,
                  position: "center",
                });
              }
            })
            .catch((err) => {
              _this.$toast({
                message: "接口调用出错",
                position: "center",
              });
            });
        }
      } else {
        this.$router.push("/login");
      }
    },
    /* 增加积分 */
    addScore() {
      let jf_params = {
        code: 'sc', // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、zbj、dy、dz、sc)
        description: "收藏", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、直播间、订阅、点赞、收藏)
        contentType: this.params.contentType, // 非必传，稿件的type
        contentId: this.params.contentId, // 非必传，稿件的id
        contentName: this.contentTitle, // 非必传，稿件的标题
      }
      if (!!this.userInfo) {
        jf_params = Object.assign(jf_params, {
          memberId: this.userInfo.id, //会员id
        });
      }
      addScore(jf_params);
    },
    /* 获取点赞状态 */
    getThumbsUpStatus() {
      var _this = this;
      var params = {
        contentType: _this.params.contentType,
        contentId: _this.detailInfo.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }
      commApi
        .queryThumbsUpStatus(params)
        .then((res) => {
          if (res.suc == 1) {

            _this.topCount = res.data.topCount;
            if (res.data.userLikes == 1) {
              var target1 = _this.$refs.praise1;
              target1.classList.add("praised");
              _this.isLiked = true;
            }else{
              _this.isLiked = false;
              
              var target1 = _this.$refs.praise1;
              if(target1)
              target1.classList.remove("praised");
            }
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
  },
  created() {
    this.allowComment = this.allow;
    this.getThumbsUpStatus(); //获取点赞状态
  },
  mounted() {
    if (!!this.userInfo && !!this.isCollect) {
      if (this.isCollect == 1) {
        var target = this.$refs.collect;
        target.classList.add("collected");
      } else {
        var target = this.$refs.collect;
        target.classList.remove("collected");
      }
    }
  },
};
</script>
<style scoped lang="scss">
.operate_box {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  display: flex;
  width: 100%;
  height: 40px;
  padding: 5px 15px;
  background-color: #fff;
  border-top: 1px solid #ebedf0;
  .comment_btn {
    width: 100%;
    height: 30px;
    background: #f0f0f0;
    border: none;
    font-size: 14px;
    color: #b3b3b3;
    .van-button__content {
      padding-left: 10px;
      padding-right: 10px;
      -webkit-justify-content: normal;
      justify-content: normal;
      text-align: left;
    }
  }
  .operate_right {
    flex: none;
    width: 95px;
    height: 30px;
    padding-left: 5px;
    line-height: 30px;
    text-align: right;
    .tj-svg-icon {
      color: #bebebe;
      vertical-align: middle;
      &.tj-icon-comment {
        font-size: 18px;
      }
      &.tj-icon-collect {
        font-size: 23px;
      }
    }
    .comment{
      margin-left: 10px;
    }
    .praise {
      margin-left: 10px;
      &.praised {
        .tj-svg-icon.tj-icon-praise {
          color: #db1e06;
        }
      }
    }
    .collect {
      margin-left: 10px;
      &.collected {
        .tj-svg-icon.tj-icon-collect {
          color: #db1e06;
        }
      }
    }
  }
}
</style>